import axios from "axios";
import store from "@/store";
import http from "http";

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  httpAgent: new http.Agent({ keepAlive: true }),
});

let controller = new AbortController();

axiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (axios.isCancel(error)) {
      controller = new AbortController();
      return Promise.reject(error);
    }
    const { status } = error.response;
    if (status === 401) {
      store.dispatch("logout").then((r) => console.log(r));
    }
    // return Promise.reject(error);
  }
);

const get = (endpoint, extraHeaders) => {
  return axiosInstance.get(endpoint, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      ...extraHeaders,
    },
  });
};

const post = (endpoint, data, extraHeaders) => {
  return axiosInstance.post(endpoint, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      ...extraHeaders,
    },
  });
};

const deleteReq = (endpoint, data, extraHeaders) => {
  return axiosInstance.delete(endpoint, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      ...extraHeaders,
    },
  });
};

const postWithFile = (endpoint, data) => {
  return axiosInstance.post(endpoint, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    },
    signal: controller.signal,
    onUploadProgress: (progressEvent) => {
      const loadingState = {
        total: progressEvent.total,
        loaded: progressEvent.loaded,
      };
      store.dispatch("calculateUploadState", loadingState);
    },
  });
};

const abortFileUpload = () => {
  controller.abort();
};

export default {
  axiosInstance,
  get,
  post,
  postWithFile,
  deleteReq,
  abortFileUpload,
};
